import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Search from "../../components/Search";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Skeleton from "react-loading-skeleton";
import "./slider.css";
import { Pagination } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSearchResults,
  setSearchCriteria,
} from "../../redux/slices/search";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Loader from "../../components/Loader/index";
import GoogleMap from "../../components/GoogleMap";
import { parseISO } from "date-fns";
import IMG from "../../assets/images/serachList/noImage.jpg";
import { createOccupancies, formatDateToEEE_MM_d } from "../../utils/utils.jsx";
import DropdownWithCheckbox from "../../components/NewDropDown";
import CustomDropdown from "../../components/NewDropDown/sortingDropdown";
import RatingDropDown from "../../components/NewDropDown/ratingsDropDown.jsx";
import TextBox from "../../components/textbox";
import { getDayDifference } from "../../utils/utils";
import { axios } from "../../utils/axios";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import NOHOTELIMG from "../../assets/images/serachList/hotel_not_found_error.png";
import { setSelectedCurrency } from "../../redux/slices/currency";
const SearchList = () => {
  const url = useLocation();
  const cardRefs = useRef([]);
  const dispatch = useDispatch();
  const state = url.state || {};
  const [infoMarker, setInfoMarker] = useState(null);
  const { token } = useSelector((state) => state.auth);
  const queryParams = new URLSearchParams(url.search);
  const tid = JSON.parse(queryParams.get("tid"));
  const locid = JSON.parse(queryParams.get("locid"));
  const checkIn = JSON.parse(queryParams.get("checkin"));
  const checkOut = JSON.parse(queryParams.get("checkout"));
  const hid = JSON.parse(queryParams.get("hid"));
  const oc = JSON.parse(queryParams.get("occupancy"));
  const [page, setPage] = useState(1);
  const scrollContainerRef = useRef(null);
  const itemsPerPage = 20;
  const [totalPages, setTotalPages] = useState();
  const [initialTimestamp, setInitialTimestamp] = useState(null);
  const [mapdataTags, setMapDataTags] = useState([]);
  const checkdates = [
    {
      startDate: checkIn !== null ? parseISO(checkIn) : null,
      endDate: checkOut !== null ? parseISO(checkOut) : null,
      key: "selection",
    },
  ];
  const [originalHoteldata, setOrignialHotelData] = useState([]);
  const [occupancy, setOccupancy] = useState(
    oc || {
      rooms: 1,
      adults: 2,
      children: [],
    }
  );
  const { loading, error, searchResults } = useSelector(
    (state) => state.search
  );
  const { selectedCurrency, currencies } = useSelector(
    (state) => state.currency
  );
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRatings, setSelectedRatings] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [sortingValue, setSortingValue] = useState();
  // ---------------------------tags-------------------------
  const [expandtags, setExpandTags] = useState(false);
  const [allTags, setAllTags] = useState(false);

  useEffect(() => {
    const chashedCurrency = localStorage.getItem("selectedCurrency");
    if (currencies.length > 0 && chashedCurrency) {
      const currencyResult = currencies.find(
        (item) => item.code === chashedCurrency
      );
      if (currencyResult) {
        dispatch(setSelectedCurrency(currencyResult));
      }
    }
  }, [currencies, dispatch]);
  useEffect(() => {
    dispatch(setSearchCriteria(null));
    setOrignialHotelData([]);
    setDisplayData([]);
    setMapDataTags([]);
    setInfoMarker(null);
    setSortingValue();
    const childages = occupancy?.children.map((child) => child.age);
    const oc = createOccupancies(
      occupancy?.rooms,
      occupancy?.adults,
      childages
    );

    const fetchData = async () => {
      const searchData = {
        tripId: tid,
        locationId: locid,
        currency: "USD",
        checkIn: formatDateToEEE_MM_d(checkIn, "UTC", "iso"),
        checkOut: formatDateToEEE_MM_d(checkOut, "UTC", "iso"),
        culture: "en-us",
        nationality: "US",
        countryOfResidence: "US",
        hotelIds: [hid],
        occupancies: oc,
        contentFields: ["Basic"],
      };
      dispatch(fetchSearchResults({ searchData: searchData }));
    };

    fetchData();
  }, []);
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND + "pins/getalltags")
      .then((resp) => {
        setAllTags(resp.data.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const onClickSubmit = (hid) => {
    const currentTime = new Date().getTime();
    if (initialTimestamp) {
      const timeDifference = (currentTime - initialTimestamp) / (1000 * 60);
      if (timeDifference > 50) {
        window.location.reload();
      } else {
        const url = `/hotel?${
          tid ? `tid=${encodeURIComponent(JSON.stringify(tid))}&` : ""
        }hid=${encodeURIComponent(
          JSON.stringify(hid)
        )}&tkid=${encodeURIComponent(
          JSON.stringify(searchResults?.token)
        )}&locid=${encodeURIComponent(
          JSON.stringify(locid)
        )}&checkin=${encodeURIComponent(
          JSON.stringify(formatDateToEEE_MM_d(checkIn, "UTC", "iso"))
        )}&checkout=${encodeURIComponent(
          JSON.stringify(formatDateToEEE_MM_d(checkOut, "UTC", "iso"))
        )}&oc=${JSON.stringify(oc)}&cid=${JSON.stringify(
          searchResults?.cid
        )}&currency=${selectedCurrency?.code || "USD"}`;

        window.open(url, "_blank", "noopener,noreferrer");
      }
    }
  };
  useEffect(() => {
    setOrignialHotelData([]);
    setDisplayData([]);
    setMapDataTags([]);
    setInfoMarker(null);
    setSortingValue();
    if (searchResults?.hotels?.length > 0) {
      const currentTime = new Date().getTime();
      setInitialTimestamp(currentTime);
      let hoteldata = [...searchResults?.hotels].sort(
        (a, b) => parseFloat(b.relevanceScore) - parseFloat(a.relevanceScore)
      );
      setOrignialHotelData(hoteldata);
      const tPages = calculateTotalPages(searchResults.hotels, itemsPerPage);
      setTotalPages(tPages);
      const paginatedData = searchResults.hotels.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      );
      setDisplayData(paginatedData);
      setMapDataTags(paginatedData);
      setInfoMarker(paginatedData[0]);
    }
  }, [searchResults?.hotels]);

  const handlePageChange = (event, value) => {
    setPage(value);
    const startIndex = (value - 1) * itemsPerPage;
    const endIndex = value * itemsPerPage;
    const paginatedData = originalHoteldata.slice(startIndex, endIndex);
    setDisplayData(paginatedData);
    setMapDataTags(paginatedData);
    setInfoMarker(paginatedData[0]);
    scrollHandler();
  };

  const scrollHandler = (e) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth", // Optional for a smooth scrolling effect
      });
    }
  };

  const handleImageError = (e) => {
    e.target.src = IMG;
  };
  // -----Pagenation-----------------
  const calculateTotalPages = (data, itemsPerPage) => {
    if (!data || data.length === 0 || itemsPerPage <= 0) return 0;
    return Math.ceil(data.length / itemsPerPage);
  };
  const handleSort = (criteria) => {
    let sortedArray = [...originalHoteldata];

    switch (criteria) {
      case "priceLowToHigh":
        sortedArray.sort((a, b) => a.rate.totalRate - b.rate.totalRate);
        break;

      case "priceHighToLow":
        sortedArray.sort((a, b) => b.rate.totalRate - a.rate.totalRate);
        break;

      case "ratingHighToLow":
        sortedArray.sort((a, b) => b.rating - a.rating);
        break;

      case "ratingLowToHigh":
        sortedArray.sort((a, b) => a.rating - b.rating);
        break;

      default:
        break;
    }
    setSortingValue(criteria);
    setOrignialHotelData(sortedArray);
    const tPages = calculateTotalPages(sortedArray, itemsPerPage);
    setTotalPages(tPages);
    const paginatedData = sortedArray.slice(
      (page - 1) * itemsPerPage,
      page * itemsPerPage
    );
    setInfoMarker(paginatedData[0]);
    setDisplayData(paginatedData);
    setMapDataTags(paginatedData);
    setPage(1);
    scrollHandler();
  };

  const handleSelectionChange = (updatedSelection) => {
    if (originalHoteldata.length !== 0) {
      setSelectedItems((prev) => ({
        ...prev,
        ...updatedSelection, // Merge the updated selection into the previous state
      }));
      let updatvalue = { ...selectedItems, ...updatedSelection };
      const filteredHotelsss = filterHotels({
        freeBreakfast: updatvalue?.freeBreakfast,
        freeCancellation: updatvalue?.freeCancellation,
      });
      setOrignialHotelData(filteredHotelsss);
      const tPages = calculateTotalPages(filteredHotelsss, itemsPerPage);
      setTotalPages(tPages);
      const paginatedData = filteredHotelsss.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      );
      setDisplayData(paginatedData);
      setMapDataTags(paginatedData);
      setInfoMarker(paginatedData[0]);
      setPage(1);
      scrollHandler();
    }
  };
  const filterHotels = (filters) => {
    return searchResults?.hotels.filter((hotel) => {
      const hasFreeBreakfast = filters?.freeBreakfast
        ? hotel?.options.freeBreakfast === true
        : true;

      const hasParking = filters?.parking
        ? hotel.facilities.includes("Parking")
        : true;

      const hasFreeCancellation = filters?.freeCancellation
        ? hotel.options.freeCancellation === true
        : true;

      if (filters?.freeCancellation && filters?.freeBreakfast) {
        return hasFreeCancellation && hasFreeBreakfast;
      }
      if (filters?.freeCancellation && !filters?.freeBreakfast) {
        return hasFreeCancellation;
      }

      if (filters?.freeBreakfast && !filters?.freeCancellation) {
        return hasFreeBreakfast;
      }

      return (
        (filters?.freeBreakfast === true ? hasFreeBreakfast : true) &&
        (filters?.freeCancellation === true ? hasFreeCancellation : true) &&
        (filters?.parking === true ? hasParking : true)
      );
    });
  };
  const handleRatingChange = (updatedSelection) => {
    if (originalHoteldata && originalHoteldata.length !== 0) {
      setSelectedRatings(updatedSelection);
      const selectedStarRatings = Object.keys(updatedSelection).filter(
        (key) => updatedSelection[key]
      );

      // If no star ratings are selected, return all hotels
      const filtered =
        selectedStarRatings.length === 0
          ? searchResults?.hotels
          : searchResults?.hotels.filter((item) =>
              selectedStarRatings.includes(item.starRating)
            );

      setOrignialHotelData(filtered);
      const tPages = calculateTotalPages(filtered, itemsPerPage);
      setTotalPages(tPages);

      // Paginate the filtered data
      const paginatedData = filtered.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      );
      setDisplayData(paginatedData);
      setMapDataTags(paginatedData);
      setInfoMarker(paginatedData[0]);
      setPage(1);
      scrollHandler();
    }
  };
  const handleSearch = (e) => {
    const { value } = e.target;

    if (value.trim() === "") {
      setOrignialHotelData(searchResults?.hotels);
      const tPages = calculateTotalPages(searchResults?.hotels, itemsPerPage);
      setTotalPages(tPages);
      const paginatedData = searchResults?.hotels.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      );
      setDisplayData(paginatedData);
      setMapDataTags(paginatedData);
      setInfoMarker(paginatedData[0]);
      setPage(1);
    } else {
      const filtered = searchResults?.hotels.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase())
      );
      setOrignialHotelData(filtered);
      const tPages = calculateTotalPages(filtered, itemsPerPage);
      setTotalPages(tPages);
      const paginatedData = filtered.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      );
      setDisplayData(paginatedData);
      setMapDataTags(paginatedData);
      setInfoMarker(paginatedData[0]);
      setPage(1);
      scrollHandler();
    }
  };
  const scrollToCard = (index) => {
    if (cardRefs.current[index]) {
      cardRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };
  return (
    <div className="container-fluid p-0">
      <div className="bxShadow">
        <Search
          tripId={tid}
          loc={locid}
          dates={checkdates}
          occupancies={occupancy}
          travellers={searchResults?.travellers}
          open={state?.open || false}
        />
        <div
          className="d-flex  align-items-center schbar-first-cont  schbar-ss-cont "
          style={{ gap: "20px", overflowX: "auto" }}
        >
          <div className="m-0 ">
            <p>{originalHoteldata.length} results </p>
          </div>
          <TextBox
            fullWidth
            name="name"
            placeholder="Search by hotel name"
            onChange={handleSearch}
            style={{
              borderRadius: "50px",
              fontSize: "14px",
              padding: " 5px 10px",
              border: "2px solid var(--light-grey)",
            }}
            mbtcls="mbclass"
          />
          <DropdownWithCheckbox
            options={populatFilter}
            selectedItems={selectedItems}
            onChange={handleSelectionChange}
            buttonLabel="Popular Filters"
          />
          <RatingDropDown
            options={ratingsOptions}
            selectedItems={selectedRatings}
            onChange={handleRatingChange}
            buttonLabel="Ratings"
          />
          <CustomDropdown
            value={sortingValue}
            onChange={handleSort}
            options={sortOptions}
            placeholder="Sort By"
          />
        </div>
      </div>

      <div className="row mx-4 " style={{ height: "79vh", overflow: "scroll" }}>
        {loading ? (
          <div className="col-lg-7 col-md-7   d-flex align-items-center justify-content-center">
            <Loader />
          </div>
        ) : displayData && displayData.length > 0 ? (
          <div
            className="col-md-7 px-2 p-0   scroll-container mt-4 "
            style={{ height: "80vh", overflow: "scroll" }}
            ref={scrollContainerRef}
          >
            <p
              className="py-2 px-0 "
              style={{
                color: "var(--white-color)",
                background: "var(--btn-liner-gradient)",
                borderRadius: "4px",
                textAlign: "center",
              }}
            >
              {searchResults?.displaymsg}
            </p>

            {displayData &&
              displayData.map((hdata, index) => (
                <div
                  className="bxShadow mb-0 cardcont sclistcard c-pointer sclcardheight "
                  key={hdata?.id}
                >
                  <div
                    className="row"
                    key={hdata?.id}
                    onClick={() => setInfoMarker(hdata)}
                    ref={(el) => (cardRefs.current[index] = el)}
                  >
                    <div className="col-lg-3 ">
                      <div className="slider-container">
                        {loading ? (
                          <Skeleton height={"100%"} />
                        ) : (
                          <img
                            src={hdata?.heroImage}
                            style={{
                              width: "100%",
                              // objectFit: "cover",
                            }}
                            className="img-schl-hero"
                            onError={handleImageError}
                            loading="lazy"
                            alt=""
                          />
                        )}
                      </div>
                    </div>
                    <div className="col-lg-9 ">
                      <div className="p-2">
                        {loading ? (
                          <Skeleton width={"100%"} />
                        ) : (
                          <div className="d-flex align-items-center justify-content-between">
                            <p className="fs-8">
                              {loading ? (
                                <Skeleton width={"10%"} />
                              ) : (
                                `${hdata.starRating} -star hotel`
                              )}
                            </p>
                            {hdata?.discount !== 0 && (
                              <div
                                className="d-flex align-items-center px-2 fw-400"
                                style={{
                                  borderRadius: "50px",
                                  background: "var(--yellow-color)",
                                  color: "var(--white-color)",
                                  gap: 5,
                                }}
                              >
                                <p className="fs-8">
                                  {hdata?.userRole} Traveler{" "}
                                </p>
                                <p className="fs-8 ">{hdata?.discount}%</p>
                              </div>
                            )}
                          </div>
                        )}
                        <h3 className="mt-1">
                          {loading ? <Skeleton width={"50%"} /> : hdata?.name}
                        </h3>
                        <p className="mt-1">
                          {" "}
                          {loading ? <Skeleton width={"40%"} /> : hdata?.miles}
                        </p>

                        <div className="d-flex pe-2 align-items-start justify-content-between">
                          <div>
                            {loading ? (
                              <Skeleton width={"10%"} />
                            ) : (
                              <>
                                {hdata?.reviews?.length !== 0 && (
                                  <p className=" fs-8">
                                    <span>{hdata?.ratings}</span>

                                    <span>
                                      ({hdata?.reviews?.length} reviews)
                                    </span>
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                          <div style={{ textAlign: "end" }}>
                            {loading ? (
                              <Skeleton width={100} />
                            ) : (
                              <>
                                {hdata?.discount !== 0 && (
                                  <p
                                    className="fs-10 fw-700  "
                                    style={{
                                      color: "var(--grey-color)",
                                      textDecoration: "line-through",
                                      textDecorationColor: "var(--red-color)",
                                    }}
                                  >
                                    ${hdata?.rate?.totalRate.toFixed(2)}
                                  </p>
                                )}
                                {hdata?.rate?.discountPrice && (
                                  <>
                                    {token ? (
                                      <></>
                                    ) : (
                                      <p className="fs-8">
                                        <span style={{ color: "#e67e22" }}>
                                          Save up to 20%
                                        </span>
                                      </p>
                                    )}
                                    <p
                                      className="fs-12 fw-700 "
                                      style={
                                        token ? {} : { filter: `blur(3px)` }
                                      }
                                    >
                                      {selectedCurrency?.symbol || "$"}{" "}
                                      {(
                                        parseFloat(
                                          hdata?.rate?.discountPrice *
                                            (selectedCurrency?.value ?? 1)
                                        ) /
                                        parseInt(
                                          getDayDifference(checkIn, checkOut) *
                                            parseInt(oc?.rooms)
                                        )
                                      ).toFixed(2)}
                                    </p>

                                    <p
                                      className="fs-8"
                                      style={{ color: "var(--grey-color)" }}
                                    >
                                      {oc?.rooms === 1
                                        ? "average nightly"
                                        : "average per room"}
                                    </p>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                        {loading ? (
                          <Skeleton />
                        ) : (
                          <div className="d-flex pe-2 align-items-center justify-content-between mt-2">
                            <div className="d-flex align-items-center flexWrap ">
                              <p
                                className=" fs-8  d-flex align-items-center "
                                style={
                                  hdata?.options?.freeBreakfast === true
                                    ? { color: "var(--secondary-color)" }
                                    : { color: "var(--red-color)" }
                                }
                              >
                                {hdata?.options?.freeBreakfast === true ? (
                                  <>
                                    {" "}
                                    <CheckCircleOutlineIcon
                                      className="me-1"
                                      style={{ width: "15px", height: "15px" }}
                                    />{" "}
                                    Includes Breakfast
                                  </>
                                ) : (
                                  ""
                                )}{" "}
                              </p>
                              <p
                                className="fs-8 d-flex align-items-center ms-2"
                                style={
                                  hdata?.options?.freeCancellation === true
                                    ? { color: "var(--secondary-color)" }
                                    : { color: "var(--red-color)" }
                                }
                              >
                                {hdata?.options?.freeCancellation === true ? (
                                  <>
                                    {" "}
                                    <CheckCircleOutlineIcon
                                      className="me-1"
                                      style={{ width: "15px", height: "15px" }}
                                    />{" "}
                                    Free Cancellation
                                  </>
                                ) : (
                                  ""
                                )}
                              </p>
                            </div>
                            {token ? (
                              <button
                                className="btn-contained signupsavings"
                                onClick={() => onClickSubmit(hdata?.id)}
                              >
                                Select
                              </button>
                            ) : (
                              <button
                                className="btn-contained signupsavings"
                                onClick={() =>
                                  (window.location.href = "/login")
                                }
                              >
                                SignUp for Savings!
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            <div className="d-flex  justify-content-center mt-5">
              <Pagination
                count={totalPages}
                variant="outlined"
                page={page}
                onChange={handlePageChange}
              />
            </div>
          </div>
        ) : (
          <div className="col-lg-7 col-md-7  d-flex align-items-center justify-content-center flex-column">
            {" "}
            <img
              src={NOHOTELIMG}
              alt="nohotel"
              className="w30"
              loading="lazy"
            />
            {checkIn !== null && checkIn !== undefined && checkIn !== "" ? (
              <p>
                No hotels found for the selected dates. Please change the dates
                and try again.{" "}
              </p>
            ) : (
              <p>Please select a location and dates to search for hotels.</p>
            )}
          </div>
        )}
        <div
          className="col-md-5 bxShadow m-0 p-0 mt-3 hidecls"
          style={{ borderRadius: "8px", position: "relative" }}
        >
          <>
            <div
              style={{
                position: "absolute",
                left: "20px",
                background: "var(--white-color)",
                zIndex: "999",
                borderRadius: "8px",
                transition: "height 0.3s ease",
                height: expandtags === true ? "auto" : "25px",
                overflow: "hidden",
              }}
              className=" mt-4 bxShadow"
            >
              <button
                className="toggle-button w100 fw-600"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  marginRight: "8px",
                }}
                onClick={() => setExpandTags((prev) => !prev)}
              >
                {expandtags === true ? (
                  <div className="d-flex align-items-center  justify-content-center">
                    {" "}
                    Bucketlist <ArrowUpwardIcon
                      style={{ width: "18px" }}
                    />{" "}
                  </div>
                ) : (
                  <div
                    div
                    className="d-flex align-items-center justify-content-center"
                  >
                    {" "}
                    Bucketlist <ArrowDownwardIcon
                      style={{ width: "18px" }}
                    />{" "}
                  </div>
                )}
              </button>
              {allTags &&
                allTags.map((item, index) => (
                  <div
                    style={{
                      borderBottom: "1px solid var(--light-grey)",
                      padding: "12px",
                      fontSize: "14px",
                    }}
                    key={index}
                    className="c-pointer d-flex align-items-center pin-hover-home"
                    onClick={() => {
                      setMapDataTags([...displayData, ...item.pins]);
                      setInfoMarker(displayData[0]);
                    }}
                  >
                    <p className="ms-2">{item.name}</p>
                  </div>
                ))}
            </div>

            <GoogleMap
              markerData={mapdataTags}
              zoom={mapdataTags !== 0 && mapdataTags !== undefined ? 10 : 15}
              setInfoMarkerData={infoMarker}
              noofDays={parseInt(
                getDayDifference(checkIn, checkOut) * parseInt(oc?.rooms)
              ).toFixed(2)}
              currency={selectedCurrency}
              noofrooms={parseInt(oc?.rooms)}
              onCardClick={scrollToCard}
            />
          </>
        </div>
      </div>
    </div>
  );
};

export default SearchList;
const populatFilter = [
  {
    id: 2,
    name: "freeBreakfast",
  },
  {
    id: 4,
    name: "freeCancellation",
  },
];
const ratingsOptions = [
  { id: "1", label: "5 star", value: "5" },
  { id: "2", label: "4 star", value: "4" },
  { id: "3", label: "3 star", value: "3" },
  { id: "4", label: "2 star", value: "2" },
  { id: "5", label: "1 star", value: "1" },
];
const sortOptions = [
  { value: "priceLowToHigh", label: "Price (Low to High)" },
  { value: "priceHighToLow", label: "Price (High to Low)" },
  { value: "ratingHighToLow", label: "Rating (High to Low)" },
  { value: "ratingLowToHigh", label: "Rating (Low to High)" },
];
